import {makeStyles} from "@material-ui/core/styles";
import {colors} from '../../shared/colors'

const useStyles = makeStyles( theme => ({

    footerPrimary: {
        background: colors.californiaBlue,
        display: 'flex',
        flexDirection: 'column',
        fontSize: '1.4rem'
    },
    footerSecondary: {
        background: colors.magellan80Black,
        borderTop: `1px solid ${colors.magellan60Black}`
    },
    primaryTop: {
        paddingLeft: '10px',
        paddingRight: '10px'
    },
    topLinksWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '2rem 0 0 14px',
    },
    primaryTopLink1:{
        fontFamily: 'Segoe UI, Noto Sans, sans-serif',
        fontSize: '14px',
        color: 'white',
        fontWeight: 'bold',
        padding: 0,
        marginBottom: '.5rem',
        textTransform: 'none',
        textDecoration: 'underline',
        '& :hover': {
          textDecoration: 'underline',
          color: colors.californiaYellow
        },
        '&:focus-visible': {
          color: colors.californiaYellow,
          outline: `3px solid ${colors.dhcsWhite}`
        }
    },
    primaryTopLink2:{
        fontFamily: 'Segoe UI, Noto Sans, sans-serif',
        color: 'white',
        padding: 0,
        textTransform: 'none',
        textDecoration: 'underline',
        '& :hover': {
          textDecoration: 'underline',
          color: colors.californiaYellow
        },
        '&:focus-visible': {
          color: colors.californiaYellow,
          outline: `3px solid ${colors.dhcsWhite}`
        }
    },
    langLinks: {
        fontFamily: 'Segoe UI, Noto Sans, sans-serif',
        color: 'white',
        padding: '0 11px 0 11px',
        marginBottom: '14px',
        textTransform: 'none',
        textDecoration: 'underline',
        '&:hover':{
            color: colors.californiaYellow,
            textDecoration: 'underline'
        },
        '&:focus-visible': {
            color: colors.californiaYellow,
            outline: `3px solid ${colors.dhcsWhite}`
        }
    },
    langLinksWrapper: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: '40px',
        paddingBottom: '30px'
    },
    footerBottomLinks:{
        fontFamily: 'Segoe UI, Noto Sans, sans-serif',
        color: 'white',
        textTransform: 'none',
        fontWeight: 'bold',
        '&:hover':{
            color: colors.californiaYellow,
            textDecoration: 'underline'
        },
        '&:focus-visible': {
            color: colors.californiaYellow,
            outline: `3px solid ${colors.dhcsWhite}`
        }
    },
    bottomLinkWrapper: {
        display: 'flex',
        padding: '0.3rem',
        borderTop: '1px solid #c7c7c7',
        flexDirection: 'row',
        justifyContent: 'center'
    }
}));

export default useStyles;